interface ErrorMessage  {
  i18n: string;
  reason: string;
};

export const errorMessages: { [key: string]: ErrorMessage } = {
  'Hot key is already registered.': {
    i18n: 'hot_key_registered',
    reason: '快捷键冲突',
  },
};
